import React from 'react';
import { FormikValues, FormikErrors } from 'formik';
import { Alert, Button, Field, HeaderSection } from '@groupelacentrale/contact-storybook';
import { ResetPasswordStateProps } from './ResetPasswordForm';
import './LoginForm.scss';

interface Props {
  email: string;
  isSubmitting: boolean;
  state: ResetPasswordStateProps;
  errors: FormikErrors<FormikValues>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const ResetPasswordFormView: React.FC<Props> = ({
  email,
  isSubmitting,
  state,
  errors,
  handleChange,
  handleSubmit,
}) => (
  <form className="login-form" onSubmit={handleSubmit}>
    <HeaderSection noUnderline>Réinitialisez votre mot de passe</HeaderSection>
    <p>
      Saisissez l&apos;identifiant de votre compte La Centrale.
      <br />
      Vous recevrez un e-mail qui vous permettra de modifier votre mot de passe.
    </p>
    <Field name="email" placeholder="Adresse email" value={email} onChange={handleChange} errorMessage={errors.email} />
    <Button
      label="Envoyer lien de réinitialisation"
      type="submit"
      theme="primary"
      disabled={isSubmitting}
      loading={isSubmitting}
    />
    {state.isSent && <p>Lien envoyé</p>}
    {state.errorMessage && <Alert type="error">{state.errorMessage}</Alert>}
  </form>
);
